import { FC } from 'react';
import { Outlet } from 'react-router';

import { useAccess } from 'hooks/useAccess';
import NoAccessState from 'components/UI/NoAccessState';

// Access route
type Props = {
  allow: string;
};

export const AccessRoute: FC<Props> = ({ allow }) => {
  const {
    readDeviceAccess,
    updateDeviceAccess,
    setDesiredAccess,
    softwareUploadAccess,
    softwareAccess,
    rolloutAccess,
    createRolloutAccess,
    startRolloutAccess,
    assignSoftwareAccess,
    readLwm2mLogsAccess,
    husqiotBusAccess,
  } = useAccess();
  if (allow === "readDeviceAccess" && !readDeviceAccess) {
    return <NoAccessState />;
  }
  if (allow === "updateDeviceAccess" && !updateDeviceAccess) {
    return <NoAccessState />;
  }
  if (allow === "setDesiredAccess" && !setDesiredAccess) {
    return <NoAccessState />;
  }
  if (allow === "softwareUploadAccess" && !softwareUploadAccess) {
    return <NoAccessState />;
  }
  if (allow === "softwareAccess" && !softwareAccess) {
    return <NoAccessState />;
  }
  if (allow === "createRolloutAccess" && !createRolloutAccess) {
    return <NoAccessState />;
  }
  if (allow === "startRolloutAccess" && !startRolloutAccess) {
    return <NoAccessState />;
  }
  if (allow === "assignSoftwareAccess" && !assignSoftwareAccess) {
    return <NoAccessState />;
  }
  if (allow === "readLwm2mLogsAccess" && !readLwm2mLogsAccess) {
    return <NoAccessState />;
  }
   if (allow === "husqiotBusAccess" && !husqiotBusAccess) {
    return <NoAccessState />;
  }
   if (allow === "rolloutAccess" && !rolloutAccess) {
    return <NoAccessState />;
  }
  return <Outlet />;
};
